import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import clipboardImg from './img/clipboard-line.png'


class CopyBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            copied:false
        }
    }

    render() {
        let me = this
        if ( this.state.copied ) {
            setTimeout(()=>{
                me.setState({copied:false})
            },1000)
        }

        return <CopyToClipboard text={this.props.text}
                onCopy={() => {this.setState({copied:true})}}>
            <div onClick={e=>{e.stopPropagation()}} className={this.state.copied ? 'copy_idt copied_idt' : 'copy_idt'}>
            
                <span title="Cliquer pour copier"><img src={clipboardImg}/>&nbsp;{this.props.displayText || this.props.text}</span>
                <span className="notice_copy_idt">Copié !</span>
            </div>
        </CopyToClipboard>

    }
}

export default CopyBox;
